import { ServiceType } from "../../../../features/Booking-Form/typings/booking-service-administration.types";

export const getColor = (
  type: ServiceType,
  filterByType: ServiceType[] | undefined,
  defaultColor: string
): string => {
  // If filterByType is undefined → show default color
  // If defined but doesn't include the type → grey
  // If defined and includes the type → default color
  if (!filterByType) return defaultColor;
  return filterByType.includes(type) ? defaultColor : "grey";
};

export default function useServiceTypeColor(filterByType?: ServiceType[]) {
  const cateringColor = getColor(ServiceType.Catering, filterByType, "#fec7c0");
  const equipmentColor = getColor(ServiceType.Bookable_Equipment, filterByType, "#b1b9fd");
  const layoutColor = getColor(ServiceType.Room_Layout, filterByType, "#86e1e3");
  const roomMergeColor = "#84c3e4";

  return { cateringColor, equipmentColor, layoutColor, roomMergeColor };
}
